import { login, logout, getInfo } from "@/api/user";
import {
  getToken,
  setToken,
  setUser,
  removeUser,
  setRemember,
  removeRemember,
  removeToken
} from "@/utils/auth";
import { encrypt } from "@/utils/validate";
import store from "../index";

const state = {
  token: getToken(),
  username: window.sessionStorage.getItem("username"),
  name: window.sessionStorage.getItem("name"),
  projectName: window.sessionStorage.getItem("projectName")
};

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
    window.sessionStorage.setItem("name", name);
  },
  SET_USERNAME: (state, username) => {
    state.username = username;
    window.sessionStorage.setItem("username", username);
  },
  SET_project: (state, info) => {
    state.projectName = info;
    window.sessionStorage.setItem("projectName", info);
  }
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password } = userInfo;
    return new Promise((resolve, reject) => {
      login({
        username: username.trim(),
        password: password
      })
        .then(response => {
          const { data } = response;
          commit("SET_TOKEN", data.Authorization);
          commit("SET_NAME", data.account.name);
          commit("SET_USERNAME", data.account.username);
          commit("SET_project", data.account.projectName);
          setToken(data.Authorization);

          if (userInfo.remind) {
            setUser(username);
            setRemember(encrypt(password, "baobiao"));
          } else {
            removeUser();
            removeRemember();
          }

          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo()
        .then(response => {
          const { data } = response;

          if (!data) {
            reject("验证失败，请重新登录.");
          }

          const { menuTree, name } = data;

          // roles must be a non-empty array
          if (!menuTree || menuTree.length <= 0) {
            reject("没有权限");
          }

          commit("SET_NAME", name);

          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token)
        .then(() => {
          commit("SET_TOKEN", "");

          removeToken();

          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit("SET_TOKEN", "");

      removeToken();
      resolve();
    });
  }

  // dynamically modify permissions
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
